import moment from "moment";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Segment } from "semantic-ui-react";
import { displayDateFormat, fileDataFormat } from "utils/dateFormat";
import messages from "./messages";
import styles from "./styles.module.scss";
import ForecastedSegment from "components/ForecastedSegment";
import { CFItem } from "../../types";

export interface CFSummaryProps {
  date: string;
  sliceId: string;
  requirement: string;
  reqChg: string;
  excess: string;
  summary: CFItem;
  projected: boolean;
}

const ClearingFundSummary = ({
  date,
  sliceId,
  requirement,
  reqChg,
  excess,
  summary,
  projected,
}: CFSummaryProps) => {
  return (
    <div id={"cfsummary"} className={styles.header}>
      <Segment raised>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.date} />
        </button>
        <span id="report-date">
          {date ? moment(date, fileDataFormat).format(displayDateFormat) : "-"}
        </span>
        <p></p>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.slice} />
        </button>
        <span id="report-sliceId">{sliceId ? sliceId : "Latest"}</span>
        <p></p>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.req} />
        </button>
        <span id="current-req">
          {requirement}
          {summary.projected && (
            <ForecastedSegment
              cfReport={summary.projected}
              reqChg={reqChg}
              projected={projected}
            />
          )}
        </span>
        <p></p>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.excess} />
        </button>{" "}
        <span id="excess">
          {excess}
          {summary.projected && (
            <b className={styles.projectedText}>Forecasted</b>
          )}
        </span>
        <p></p>
      </Segment>
    </div>
  );
};
export default ClearingFundSummary;
